import React from 'react';
import { formatFileSize } from '../../../utils/driveUtils';

// Shown on a phone or tablet when pdf.js cannot load or render the PDF: never a blank screen.
// "Open PDF" opens the file in a new tab, where the phone's own PDF viewer takes over.
const PdfOpenCard = ({ url, filename, fileSize, isDarkMode }) => (
  <div className={`pdf-viewer pdfjs-open-card-wrap ${isDarkMode ? 'dark' : 'light'}`}>
    <div className="pdfjs-open-card" role="group" aria-label="PDF">
      <svg className="pdfjs-open-card-icon" viewBox="0 0 56 68" aria-hidden="true">
        <path d="M4 4h34l14 14v46H4z" fill="#fff" stroke="#c9ccd1" strokeWidth="2" />
        <path d="M38 4v14h14" fill="none" stroke="#c9ccd1" strokeWidth="2" />
        <rect x="0" y="36" width="40" height="18" rx="4" fill="#d9534f" />
        <text x="20" y="49" fontSize="11" fontWeight="700" fill="#fff" textAnchor="middle" fontFamily="sans-serif">
          PDF
        </text>
      </svg>
      <div className="pdfjs-open-card-name">{filename || 'PDF'}</div>
      {fileSize > 0 && <div className="pdfjs-open-card-meta">PDF · {formatFileSize(fileSize)}</div>}
      <a className="pdfjs-open-card-button" href={url} target="_blank" rel="noopener noreferrer">
        Open PDF
      </a>
      <div className="pdfjs-open-card-hint">Opens in your phone's PDF viewer: every page, pinch to zoom.</div>
    </div>
  </div>
);

export default PdfOpenCard;
